"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.product = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var product = exports.product = _propTypes["default"].shape({
  iconFileName: _propTypes["default"].string,
  ProductFullName: _propTypes["default"].string,
  ProductSymbol: _propTypes["default"].string,
  ProductId: _propTypes["default"].number
});